import { render, staticRenderFns } from "./ArticleStockDrawer.vue?vue&type=template&id=2b2c67f2&scoped=true&lang=pug&"
import script from "./ArticleStockDrawer.vue?vue&type=script&lang=js&"
export * from "./ArticleStockDrawer.vue?vue&type=script&lang=js&"
import style0 from "./ArticleStockDrawer.vue?vue&type=style&index=0&id=2b2c67f2&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2c67f2",
  null
  
)

/* custom blocks */
import block0 from "./ArticleStockDrawer.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports